import { z } from 'zod';
export const AuthUserSchema = z.object({
    id: z.number().int().min(1).optional()
});
//# sourceMappingURL=authUserSchema.js.map